import { setTheme } from "theme/default/setTheme";

export const setBorderRadius_4px = setTheme(({ theme }) => `border-radius: ${theme.borderRadius.border_radius_4px}`);
